import { AxiosError } from "axios";
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

type ErrorResponse = { message?: string };

const hasMessage = (data: unknown): data is ErrorResponse => {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const maybeMessage = (data as Record<string, unknown>).message;
  return typeof maybeMessage === "string";
};

/**
 * Formats a cover URL with cache-busting for non-Firebase URLs.
 * Firebase URLs already have built-in cache management via tokens.
 * Uses 5-minute rounded timestamp to avoid infinite re-renders.
 */
export function formatCoverUrl(url: string | null | undefined, fallback = "/placeholder.svg"): string {
  if (!url) return fallback;
  if (url.includes("firebase")) return url;
  
  // Se a URL já tem timestamp, retorna como está
  if (url.includes("?t=")) return url;
  
  // Arredonda timestamp para 5 minutos (300000ms) para evitar cache-busting excessivo
  const fiveMinutes = 5 * 60 * 1000;
  const roundedTimestamp = Math.floor(Date.now() / fiveMinutes) * fiveMinutes;
  return `${url}?t=${roundedTimestamp}`;
}

export function getErrorMessage(error: AxiosError): string {
  const responseData = error.response?.data;

  if (hasMessage(responseData)) {
    return responseData.message ?? "Erro desconhecido ao carregar dados";
  }

  if (error.message) {
    return error.message;
  }
  console.error(responseData);
  return 'Erro desconhecido ao carregar dados';
};
